import { HttpClient } from '@angular/common/http';
import { FeatureService } from './feature.service';

export function featureFactory(svc: FeatureService): () => Promise<void> {
  return () => svc.init();
}
